/* The result is its own element rather than a swap of the button's label: the failure line
   is a whole sentence, and a button that grows to hold it moves the dialog footer out from
   under the pointer that just clicked it. */

/* Positioned so the visually hidden live region below is placed against this wrapper and
   not the viewport: in the last column of a wide table it would otherwise sit past the
   right edge of the page and widen it. */
.wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: var(--sp-s);
}

/* Stroked in the button's own text colour, so it follows the ghost variant's muted rest
   and full-ink hover like a worded label would. */
.glyph {
  display: block;
  fill: none;
  stroke: currentcolor;
  stroke-width: 1.25;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.result {
  font-family: var(--font-sans);
  font-size: var(--step-n1);
  color: var(--text-muted);
}

.failed {
  color: var(--status-crit);
}

.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}
